// Textes de la carte de visite digitale. Le design est identique dans les deux langues.
export const cardCopy = {
  fr: {
    taglineTop: "Trouver plus qu’un bien.",
    taglineBottom: "Trouver votre chez-vous.",
    whatsapp: "Échanger sur WhatsApp",
    whatsappHint: "Réponse rapide, même le week-end",
    call: (name) => `Appeler ${name}`,
    email: "Envoyer un email",
    booking: "Prendre rendez-vous",
    bookingFallback: "Demander un rendez-vous",
    bookingHint: "Choisir un créneau",
    bookingFallbackHint: "Via WhatsApp, en quelques secondes",
    save: "Enregistrer le contact",
    saveHint: (name) => `Ajouter ${name} à mes contacts`,
    instagram: "Suivre sur Instagram",
    instagramHint: "Coulisses et nouveautés",
    projectEyebrow: "Votre projet",
    projectTitle: "Vous avez un projet immobilier ?",
    projectIntro: "Dites-moi simplement où vous en êtes, je m’occupe du reste.",
    sell: "Je souhaite vendre",
    sellText: "Connaître la vraie valeur de votre adresse, sans engagement.",
    sellCta: "Faire estimer mon bien",
    buy: "Je souhaite acheter",
    buyText: "Présentez-moi votre recherche, je vous alerte en priorité.",
    buyCta: "Parler de ma recherche",
    invest: "Je souhaite investir",
    investText: "Rendement, fiscalité, potentiel de travaux : on en parle.",
    investCta: "Parler investissement",
    valuesEyebrow: "Ma façon de travailler",
    valuesTitle: "Une autre façon de vivre l’immobilier.",
    values: [
      ["Transparence", "Des informations claires et un accompagnement sans mauvaises surprises."],
      ["Accompagnement", "Un interlocuteur présent de la réflexion jusqu’à la concrétisation du projet."],
      ["Honoraires fixes", "Une tarification claire et connue à l’avance pour les prestations concernées."],
    ],
    footerBaseline: "L’immobilier qui vous ressemble.",
    footerSite: "Découvrir le site",
    footerFees: "Honoraires",
    footerPrivacy: "Confidentialité",
    legal:
      "Carte de visite digitale. Les informations présentées ne constituent pas une offre contractuelle. Mentions légales et politique de confidentialité disponibles sur",
    switchLabel: "English",
    seoTitle: (name) => `${name} — Fondateur Pimp My Place | Carte de visite`,
    seoDescription: (name, area) =>
      `Contactez ${name}, fondateur de Pimp My Place. Achat, vente, estimation et accompagnement immobilier — ${area}.`,
  },
  en: {
    taglineTop: "More than a property.",
    taglineBottom: "Your place to call home.",
    whatsapp: "Chat on WhatsApp",
    whatsappHint: "Quick reply, weekends included",
    call: (name) => `Call ${name}`,
    email: "Send an email",
    booking: "Book a meeting",
    bookingFallback: "Request a meeting",
    bookingHint: "Pick a time slot",
    bookingFallbackHint: "Through WhatsApp, in seconds",
    save: "Save contact",
    saveHint: (name) => `Add ${name} to my contacts`,
    instagram: "Follow on Instagram",
    instagramHint: "Behind the scenes and new listings",
    projectEyebrow: "Your project",
    projectTitle: "Do you have a property project?",
    projectIntro: "Tell me where you stand, I take care of the rest.",
    sell: "I want to sell",
    sellText: "Know the real value of your property, with no commitment.",
    sellCta: "Get my property valued",
    buy: "I want to buy",
    buyText: "Tell me about your search and get the first look at new homes.",
    buyCta: "Discuss my search",
    invest: "I want to invest",
    investText: "Yield, taxation, renovation potential: let’s talk it through.",
    investCta: "Discuss investment",
    valuesEyebrow: "How I work",
    valuesTitle: "A different way to experience property.",
    values: [
      ["Transparency", "Clear information and guidance with no unpleasant surprises."],
      ["Guidance", "One dedicated contact from your first thoughts to the signature."],
      ["Fixed fees", "Clear pricing, known in advance for the services concerned."],
    ],
    footerBaseline: "Property that looks like you.",
    footerSite: "Visit the website",
    footerFees: "Fees",
    footerPrivacy: "Privacy",
    legal:
      "Digital business card. The information shown is not a contractual offer. Legal notice and privacy policy available on",
    switchLabel: "Français",
    seoTitle: (name) => `${name} — Founder, Pimp My Place | Digital card`,
    seoDescription: (name, area) =>
      `Contact ${name}, founder of Pimp My Place. Buying, selling and property guidance in Provence — ${area}.`,
  },
};
